import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class NowSecure extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M23.6,10.5,19.1,2.707a3.025,3.025,0,0,0-2.592-1.5H7.488A3,3,0,0,0,4.9,2.707L.4,10.464a3.021,3.021,0,0,0,0,3.014l2.247,3.86c0,.019.019.019.019.038L5.894,22.79H16.512a2.977,2.977,0,0,0,2.592-1.5L23.6,13.5A2.987,2.987,0,0,0,23.6,10.5ZM1.92,11.347,6.413,3.59a1.247,1.247,0,0,1,1.075-.614h3L3.418,15.187,1.92,12.6A1.215,1.215,0,0,1,1.92,11.347Zm12.941-2.5L16.685,12,11.5,21.043H7.814Zm7.219,3.763-4.493,7.8a1.265,1.265,0,0,1-1.075.633h-3l4.934-8.6a1.082,1.082,0,0,0,.1-.269h0v-.4c0-.02,0-.02-.019-.039v-.019a.379.379,0,0,0-.077-.154l-2.822-4.9a1.772,1.772,0,0,0-.135-.192.889.889,0,0,0-.614-.249h0a.429.429,0,0,0-.154.019h-.038a.853.853,0,0,0-.5.307h0a.019.019,0,0,1-.019.019c-.02.02-.039.058-.058.077L6.278,20.16,4.416,16.934l8.1-13.977h3.994a1.2,1.2,0,0,1,1.075.633l4.493,7.776A1.215,1.215,0,0,1,22.08,12.614Z" />
      </svg>
    );
  }
}

export default NowSecure;
